var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-uploader',{staticClass:"uploader",attrs:{"after-read":_vm.afterRead,"before-read":_vm.beforeRead,"upload-icon":"plus","multiple":""},on:{"delete":_vm.onDelete},model:{value:(_vm.fileList),callback:function ($$v) {_vm.fileList=$$v},expression:"fileList"}})
}
var staticRenderFns = []

export { render, staticRenderFns }